import { compose, head, propOr } from 'ramda';

export default function mapOfferNodeOptions (offerNode) {
  return propOr([], 'options', offerNode).map((option) => ({
    label: compose(head, propOr([], 'label'))(option),
    value: propOr(null, 'value', option),
    recommended: propOr(false, 'recommended', option),
    disabled: !propOr(false, 'editable', option)
  }));
}
